import { render, staticRenderFns } from "./picList.vue?vue&type=template&id=fdbcb4dc&scoped=true"
import script from "./picList.vue?vue&type=script&lang=js"
export * from "./picList.vue?vue&type=script&lang=js"
import style0 from "./picList.vue?vue&type=style&index=0&id=fdbcb4dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbcb4dc",
  null
  
)

export default component.exports